<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('标题')">
                <a-input v-model="queryParam.title" :placeholder="$t('请输入')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('内容')">
                <a-input v-model="queryParam.description" :placeholder="$t('请输入')" allow-clear></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('广告显示位置')">
                <a-select v-model="queryParam.position" :placeholder="$t('请选择')">
                  <a-select-option v-for="item in positionArr" :key="item.value" :value="item.value">{{
                    item.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced"> </template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd()" v-hasPermi="['banner:banner:add']">
          <a-icon type="plus" />{{ $t('新增') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['banner:banner:remove']">
          <a-icon type="delete" />{{ $t('删除') }}
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form v-if="visible" ref="createForm" @refresh="getList" @close="visible = false" />
      <!-- 详情 -->
      <detail-form v-if="detailVisible" ref="detailForm" @refresh="getList" @close="detailVisible = false" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="imgId" slot-scope="text, record">
          <div v-viewer>
            <img style="width: 20px; height: 20px" :src="record.imgId" alt="" />
          </div>
        </span>
        <span slot="position" slot-scope="text, record">
          {{ record.position | filterCommon(positionArr, 'label') }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-popconfirm :ok-text="$t('是')" :cancel-text="$t('否')" @confirm="handleStatusType(record)">
            <span slot="title"
              >{{ $t('确认') }}<b>{{ record.status === 0 ? $t('启用') : $t('停用') }}</b> {{ record.title
              }}{{ $t('的类型吗?') }}
            </span>
            <a-switch :checked-children="$t('开')" :un-checked-children="$t('关')" :checked="record.status === 1" />
          </a-popconfirm>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['banner:banner:query']" />
          <a @click="handleDetail(record.id)" v-hasPermi="['banner:banner:query']">
            {{ $t('详情') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['banner:banner:edit']" />
          <a @click="handleAdd(record.id)" v-hasPermi="['banner:banner:edit']">
            {{ $t('修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['banner:banner:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['banner:banner:remove']">
            {{ $t('删除') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `${$t('共')} ${total} ${$t('条')}`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
// import { pageProblem, listProblem, delProblem, editProblemStatus, listProblemType } from '@/api/problem/problem'
import { fetchList, delObj, putStatus } from './api'
import DetailForm from './modules/Detail'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import variableMixin from '@/core/mixins'

export default {
  name: 'Problem',
  components: {
    CreateForm,
    DetailForm
  },
  mixins: [tableMixin, variableMixin],
  data() {
    return {
      detailVisible: false,
      visible: false,
      problemTypeOptions: [],
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        title: undefined,
        description: undefined,
        position: undefined,
        pageNum: 1,
        pageSize: 10
      },

      columns: [
        { title: this.$t('标题'), dataIndex: 'title', ellipsis: true, align: 'center' },
        {
          title: this.$t('广告显示位置'),
          dataIndex: 'position',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'position' }
        },
        {
          title: this.$t('图片'),
          dataIndex: 'imgId',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'imgId' }
        },
        // { title: this.$t('内容'), dataIndex: 'description', ellipsis: true, align: 'center' },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    // 处理
    handleDealwith(record) {
      const form = {
        id: record.id,
        processResult: undefined,
        processStatus: 2
      }
      this.$confirm({
        title: this.$t('处理反馈'),
        content: (h) => (
          <div>
            <a-input v-model={form.processResult} placeholder={this.$t('请输入处理结果')}></a-input>
          </div>
        ),
        centered: true,
        onOk: () => {
          console.log('OK')
          if (!form.processResult) {
            this.$message.error('请输入处理结果')
            return Promise.reject(Error('请输入处理结果'))
          }
          putStatus(form).then((res) => {
            this.getList()
          })
        },
        onCancel: () => {
          console.log('Cancel')
        },
        class: 'test'
      })
    },
    // 查看详情
    handleDetail(id) {
      this.detailVisible = true
      this.$nextTick(() => {
        this.$refs.detailForm.init(id)
      })
    },
    handleAdd(id) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.createForm.init(id)
      })
    },
    /** 查询常见问题列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records.map((item) => {
          return {
            ...item,
            imgUrls: item.imgUrls
              ? /^\[.*\]$/.test(item.imgUrls)
                ? JSON.parse(item.imgUrls)
                : item.imgUrls.split(',')
              : ''
          }
        })
        console.log(this.list)
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 查询所属分类 */
    // getProblemTypeOptions () {
    //   listProblemType().then(response => {
    //     this.problemTypeOptions = response.data
    //   })
    // },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        problemTypeId: undefined,
        title: undefined,
        sketch: undefined,
        contentInfo: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    // 状态修改
    handleStatusType(row) {
      row.status = row.status == '0' ? '1' : '0'
      putStatus({
        id: row.id,
        status: row.status
      })
        .then(() => {
          this.$message.success(this.$t('操作成功 !'))
          this.getList()
        })
        .catch(function () {
          row.status = row.status == '0' ? '1' : '0'
        })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('提示'),
        content: this.$t('确认删除所选中数据?'),
        onOk() {
          const data = []
          that.ids.map((id) => data.push({ id: id }))
          delObj(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success(this.$t('删除成功'), 3)
          })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出?'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download(
            '/problem/export',
            {
              ...that.queryParam
            },
            `常见问题_${new Date().getTime()}.xls`
          )
        },
        onCancel() {}
      })
    }
  }
}
</script>
